import { render, staticRenderFns } from "./EnrollTabBankPayment.vue?vue&type=template&id=084137ec&scoped=true&"
import script from "./EnrollTabBankPayment.vue?vue&type=script&lang=ts&"
export * from "./EnrollTabBankPayment.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollTabBankPayment.vue?vue&type=style&index=0&id=084137ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084137ec",
  null
  
)

export default component.exports